export default "__VITE_ASSET__CTMXs5PP__"